import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { moduleApi } from "~/api";
import { ModuleSettings } from "~/features/module";
import { useBuildingContext } from "~/providers/building.provider";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/settings/bms/modules/$moduleId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { buildingId, moduleId } = Route.useParams();
  const navigate = Route.useNavigate();

  const { data: modules } = useSuspenseQuery(moduleApi.queries.building(buildingId));
  const { gateways, building, permissions } = useBuildingContext(Route.id);

  const module = modules.find(md => md.id === moduleId);
  if (!module) return null;

  return (
    <ModuleSettings
      key={module.id}
      buildingId={buildingId}
      module={module}
      modules={modules}
      gateways={gateways}
      building={building}
      permissions={permissions}
      onDeleted={() => {
        void navigate({ to: "/buildings/$buildingId/settings/bms/modules", params: { buildingId } });
      }}
    />
  );
}
